/**
 * Combines an unknown number of parts of a path into a single path string. This will ensure that there is no
 * multiple slashes between path parts.
 *
 * @param parts The parts of the path to combine into a single path.
 */
export function combinePathParts(...parts: Array<string>): string {
  // Join all parts of the path with a slash, regardless of if the previous or next part begin or end with a slash.
  return (
    parts
      // Filter any null parth parts or empty strings.
      .filter((part: string): boolean => part != null || part != '')
      // Join all parth parts with a "/".
      .join('/')
      // Replace multiple slashes not after a protocol (after a colon).
      .replace(/([^:]\/)\/+/g, '$1')
      // Remove any number of slashes preceeding a question mark. This would remove unneeded slashes directly before query params.
      .replace(/\/*([?])/, '$1')
      // Remove any trailing slashes at the end of the combined path.
      .replace(/\/+$/, '')
  );
}
